export const defaultUuid: number = 1000
export const defaultChatbotId = `bot_default${defaultUuid}`
